import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { CommonService } from '../common/services/common.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    public totalRequests = 0;
    public completedRequests = 0;

    constructor(private translate: TranslateService,
                private authenticationService: AuthenticationService,
                private commonService: CommonService ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.totalRequests++;
        //this.commonService.apiProgressChange.next({ progresscount: this.totalRequests, text: "API Request Started" });
        // add authorization header with jwt token if available
        let currentUser = this.authenticationService.User;
        if (currentUser && currentUser.access_token) {

            var takaful = "";
            const browserWindow = window || {};
            const browserWindowEnv = browserWindow['__env'] || {};
            if (browserWindowEnv.hasOwnProperty('takaful')) {
                takaful = window['__env']['takaful'];
            }

            var language = "1";
            if (this.translate.currentLang == 'ar')
                language = "2";
            else if (this.translate.currentLang == 'fr')
                language = "3";

            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.access_token}`,
                    Language: language,
                    Takaful: takaful
                }
            });
        }

        return next.handle(request).pipe(
            finalize(() => {

                this.completedRequests++;

                if (this.completedRequests === this.totalRequests) {
                    this.completedRequests = 0;
                    this.totalRequests = 0;
                    //this.commonService.apiProgressChange.next({ progresscount: this.totalRequests, text: "API Request Completed" });
                }

            })
        );
    }
}